import React, { memo, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "../components/header/Header";
import Login from "../components/pages/login/Login";
import Footer from "../components/footer/Footer";
import MainMenu from "../components/pages/main/MainMenu";
import { Page404 } from "../components/pages";
import { useRecoilValue } from "recoil";
import { userState } from "../states/userState";
import Drafts from "../components/pages/drafts/Drafts";
import DndMain from "../components/pages/dnd/DndMain";
import GoogleAnalistics from "../components/analistics/GoogleAnalistics";

const Router = memo(() => {
  const user = useRecoilValue(userState);
  return (
    <BrowserRouter>
      <GoogleAnalistics>
        <Routes>
          <Route
            path="/"
            element={
              user?.isAuth ? (
                <>
                  <Header pageTitle={""} />
                  <MainMenu />
                </>
              ) : (
                <>
                  <Header pageTitle={""} />
                  <Login />
                  <Footer />
                </>
              )
            }
          />

          {/* <Route
          path="/main"
          element={
            user?.isAuth ? (
              <>
                <Header pageTitle={""} />
                <MainMenu />
              </>
            ) : (
              <>
                <Header pageTitle={""} />
                <Login />
                <Footer />
              </>
            )
          }
        /> */}
          <Route
            path="/drafts"
            element={
              user?.isAuth ? (
                <>
                  <Header pageTitle={""} />
                  <Drafts />
                </>
              ) : (
                <>
                  <Header pageTitle={""} />
                  <Login />
                  <Footer />
                </>
              )
            }
          />
          <Route
            path="/dnd"
            element={
              user?.isAuth ? (
                <>
                  <Header pageTitle={""} />
                  <DndMain />
                </>
              ) : (
                <>
                  <Header pageTitle={""} />
                  <Login />
                  <Footer />
                </>
              )
            }
          />
          <Route
            path="/login"
            element={
              // user?.isAuth ? (
              //   <>
              //     <Header pageTitle={""} />
              //     <MainMenu />
              //   </>
              // ) : (
              //   <>
              //     <Header pageTitle={""} />
              //     <Login />
              //     <Footer />
              //   </>
              // )
              <>
                <Header pageTitle={""} />
                <Login />
                <Footer />
              </>
            }
          />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </GoogleAnalistics>
    </BrowserRouter>
  );
});

export default Router;
